<script>
    import ContactModel from "../models/contactModel";
    import LoginModel from "../models/loginModel.js";

    export default {
        props: ["nextUrl"],
        template: require("../templates/login.html"),
        data() {
            return {
                loginModel: new LoginModel(),
                showDismissibleAlert: false,
                // Theme
                themeLoginButton: this.$myThemeButton_Login,
                themeButton_success: this.$myThemeButton_success
            }
        },
        methods: {
            handleSubmit(e) {

                e.preventDefault();
                let localThis = this;
                let url = this.$localApiURL + this.loginModel.getRoute("save");
                this.loginModel.save(
                    {
                        'url': url,
                        "data": {
                            user: this.loginModel.email,
                            pass: this.loginModel.password
                        }
                    }
                ).then(result => {

                    let response = result.response;
                    if (response.data != null) {
                        if (response.data.error !== false) {
                            localThis.showDismissibleAlert = true;
                            localThis.loginModel.errorMessage = response.data.error;
                        } else if (response.data.token !== "") {
                            localThis.showDismissibleAlert = false;
                            localStorage.setItem('jwt', response.data.token);
                            this.getUserName();
                            this.isAdmin();

                        }
                    }
                }).catch((error) => {
                    localThis.showDismissibleAlert = true;
                    localThis.loginModel.errorMessage = error;
                    console.error(error);

                });

            },
            getUserName() {
                this.contactModel = new ContactModel();
                let url = this.$localApiURL + this.contactModel.getRoute("fetch");
                this.contactModel.fetch({
                    'url': url,
                    params: {token: localStorage.getItem('jwt')}
                }).then(result => {
                console.log("🚀 ~ getUserName ~ result:", result)

                    localStorage.setItem("contactId", result.response.data.contactId);
                    localStorage.setItem("clientID", result.response.data.clientId);
                    localStorage.setItem("userName", result.response.data.name + "," + result.response.data.clientName);
                    localStorage.setItem("parent_client_id", result.response.data.parent_client_id);
                    this.$router.push("/Welcome");
                    // Vue.$forceUpdate();
                }).catch((error) => {
                    console.error(error);
                });
            },
            isAdmin() {
                let url = `${this.$localApiURL}authorization/isAdmin`;
                this.$http.get(url, {
                    headers: {"Bearer": localStorage.getItem("jwt")}
                }).then(res => {

                    let data = res.data;
                    if (data != null && data === true) {
                        localStorage.setItem("isAdmin", "true");
                    } else {
                        localStorage.setItem("isAdmin", "false");
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Login.vue